<template>
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px">
        <el-form-item label="账户类型" prop="bankAccountType">
          <!-- <el-input :disabled="true" v-model="ruleForm.bankAccountType" placeholder="" clearable></el-input> -->
          <div v-if="id == 0">
            <el-radio-group v-model="ruleForm.bankAccountType">
              <el-radio :label="'BANK_ACCOUNT_TYPE_CORPORATE'">对公银行账户</el-radio>
              <el-radio :label="'BANK_ACCOUNT_TYPE_PERSONAL'">个人银行卡账户</el-radio>
            </el-radio-group>
          </div>
          <p v-if="id != 0">对公银行账户</p>
          <p v-if="ruleForm.bankAccountType == 'BANK_ACCOUNT_TYPE_CORPORATE'" class="labels-tips">
            你为经营者对公银行账户，请务必填写开户名为#商户名称#的银行账户
          </p>
          <p v-if="ruleForm.bankAccountType == 'BANK_ACCOUNT_TYPE_PERSONAL'" class="labels-tips">
            你为经营者个人银行卡，请务必填写开户名为#经营者名称#的银行账户
          </p>
        </el-form-item>
        <el-form-item label="是否同名账户" prop="isSameAccount" v-if="id == 2">
          <div>
            <el-radio-group v-model="ruleForm.isSameAccount">
              <el-radio :label="0">结算至同名账户</el-radio>
              <el-radio :label="1">结算至非同名账户</el-radio>
            </el-radio-group>
          </div>
          <p v-if="ruleForm.isSameAccount == 0" class="labels-tips">请务必填写开户名称为“商户名称”的银行账号</p>
          <p v-if="ruleForm.isSameAccount == 1" class="labels-tips">
            原则上，开户名称必须与主体一致，若因特殊原因需结算至非同名账户，请确认贵方与该银行账户存在合法资金管理关系，否则需承担相关法律责任
          </p>
        </el-form-item>
        <el-form-item label="开户名称" prop="accountName" class="account">
          <el-input
            v-if="(ruleForm.bankAccountType == 'BANK_ACCOUNT_TYPE_CORPORATE' || ruleForm.isSameAccount == 1) && id != 0"
            v-model="ruleForm.accountName"
            placeholder=""
            clearable
          ></el-input>
          <span
            v-if="
              (ruleForm.bankAccountType == 'BANK_ACCOUNT_TYPE_CORPORATE' && id != 2) ||
              (ruleForm.isSameAccount == 0 && ruleForm.bankAccountType == 'BANK_ACCOUNT_TYPE_CORPORATE')
            "
            class="name"
            >请填写开户人姓名</span
          >
          <span v-if="ruleForm.bankAccountType == 'BANK_ACCOUNT_TYPE_PERSONAL' && id != 2" class="name"
            >请填写经营者姓名</span
          >
        </el-form-item>
        <!-- <el-form-item label="开户银行省市" prop="bankAddressCode">
          <el-input v-model="ruleForm.bankAddressCode" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="开户银行联行号" prop="bankBranchId">
          <el-input v-model="ruleForm.bankBranchId" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="开户银行全称" prop="bankName">
          <el-input v-model="ruleForm.bankName" placeholder="" clearable></el-input>
        </el-form-item> -->
        <div class="backList">
          <el-form-item label="开户行" prop="accountBank" class="account">
            <div>
              <el-select v-model="ruleForm.accountBank" placeholder="请选择" @change="changeBack">
                <el-option v-for="index in backList" :key="index" :label="index" :value="index"> </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item v-if="bankType" label="" prop="" class="account" style="margin-left: -120px">
            <div>
              <el-select v-model="ruleForm.backName" placeholder="请选择">
                <el-option v-for="index in otherBankList" :key="index" :label="index" :value="index"> </el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
        <!-- <el-form-item label="开户支行" prop="">
          <div class="area">
            <el-select v-model="ruleForm.province" placeholder="省份" style="width: 140px" @change="changeProvince">
              <el-option v-for="item in provinceListData" :key="item.id" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
            <el-select v-model="ruleForm.city" placeholder="城市" style="width: 150px" @change="changeCity">
              <el-option v-for="item in cityListData" :key="item.id" :label="item.name" :value="item.name"> </el-option>
            </el-select>
            <el-select v-model="ruleForm.subBranch" placeholder="请选择支行" style="width: 240px">
              <el-option v-for="index in subBranch" :key="index" :label="index" :value="index"> </el-option>
            </el-select>
          </div>
        </el-form-item> -->

        <div class="province">
          <el-form-item label="开户支行" prop="">
            <el-select v-model="ruleForm.province" placeholder="省份" @change="changeProvince">
              <el-option v-for="item in provinceListData" :key="item.id" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="" style="margin-left: -120px">
            <el-select v-model="ruleForm.city" placeholder="城市" @change="changeCity">
              <el-option v-for="item in cityListData" :key="item.id" :label="item.name" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="" style="margin-left: -120px">
            <el-select v-model="ruleForm.accountBranch" placeholder="请选择支行" @change="changeSubBranch">
              <el-option v-for="index in subBranch" :key="index" :label="index" :value="index"> </el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item v-if="subBranchType" label="填写支行名称" prop="accountBranchName" class="account">
          <el-input v-model="ruleForm.accountBranchName" placeholder="" clearable></el-input>
          <p class="labels-tips">示例：中国XXX银行股份有限公司XXXXXX支行</p>
        </el-form-item>
        <el-form-item label="银行账号" prop="accountNumber" class="account">
          <el-input v-model="ruleForm.accountNumber" placeholder="" clearable></el-input>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    allData: {
      type: Object,
      default: () => {},
    },
    backList: {
      type: Array,
      default: () => [],
    },
    provinceListData: {
      type: Array,
      default: () => [],
    },
    cityListData: {
      type: Array,
      default: () => [],
    },
    subBranch: {
      type: Array,
      default: () => [],
    },
    otherBankList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ruleForm: {
        bankAccountType: 'BANK_ACCOUNT_TYPE_CORPORATE',
        accountName: '',
        bankAddressCode: '',
        bankBranchId: '',
        bankName: '',
        accountNumber: '',
        province: '',
        isSameAccount: 0,
        city: '',
        subBranch: '',
        accountBranch: '',
        accountBank: '',
        backName: '',
        accountBranchName: '',
      },
      rules: {
        bankAccountType: [{ required: true, message: '', trigger: ['blur', 'change'] }],
        // accountName: [{ required: true, message: '请输入开户名称', trigger: ['blur', 'change'] }],
        bankAddressCode: [{ required: true, message: '请输入开户银行省市', trigger: ['blur', 'change'] }],
        bankBranchId: [{ required: true, message: '请输入开户银行联行号', trigger: ['blur', 'change'] }],
        bankName: [{ required: true, message: '请输入开户银行全称', trigger: ['blur', 'change'] }],
        accountNumber: [{ required: true, message: '请输入银行账号', trigger: ['blur', 'change'] }],
        province: [{ required: true, message: '请选择地区', trigger: ['blur', 'change'] }],
        accountBranchName: [{ required: true, message: '请填写支行名称', trigger: ['blur', 'change'] }],
      },
      bankType: false,
      subBranchType: false,
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
  },
  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    allData: {
      handler: function (data) {
        console.log(data);
        if (data.settlementBankAccountVO) {
          this.ruleForm = data.settlementBankAccountVO;
        }
      },
    },
  },

  methods: {
    changeBack(val) {
      if (val == '其他银行') {
        this.bankType = true;
      } else {
        this.bankType = false;
      }
      this.$emit('changeBack', val);
    },
    changeSubBranch(val) {
      if (val == '其他银行') {
        this.subBranchType = true;
      } else {
        this.subBranchType = false;
      }
      this.$emit('changeSubBranch', val);
    },
    changeProvince(val) {
      this.$emit('changeProvince', val);
      console.log(val);
    },
    changeCity(val) {
      this.$emit('changeCity', val);
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}

.labels-tips {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
}
.name {
  font-size: 12px;
  font-weight: 500;
  color: #333;
}
.account {
  /deep/.el-input {
    width: 346px;
  }
}

// .area {
//   /deep/.el-select {
//     margin-right: 20px;
//   }
// }
.backList {
  display: flex;
  /deep/.el-input--suffix {
    width: 180px;
  }
}
.province {
  display: flex;
}
</style>
